export default "__VITE_ASSET__DiS3SUlV__"